import React, {Component} from 'react';

import { connect } from 'react-redux';

import { dashBoardAction } from '../../../_actions/dashBoard/dashBoardActions';
import { GroupReportAction } from '../../../_actions/organisations/groupReport.action';
import { DownloadPdfEndPoint } from './DownloadPdfEndPoint';

import './ReportDownload.css';

class ReportDownlaod extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            errorMessage: ''
        }
    }
    componentDidMount() {

        let that = this;

        let dataLocalStorage = localStorage.getItem('download-obj')
        let unstringlyDataObj = JSON.parse(dataLocalStorage)

      
        let dataObj = {}
        if(unstringlyDataObj.key !== 'group') {
            if(unstringlyDataObj.key === 'plan') {
                dataObj = { 
                    "user_assessment":unstringlyDataObj.data.user_assessment,
                    "user": unstringlyDataObj.data.user, 
                    "dev_plan_id": unstringlyDataObj.data.data.id, 
                    "dev_plan_name": unstringlyDataObj.data.data.development_plan_name
                }
            }else if(unstringlyDataObj.key === 'selfDevPlan'){
                dataObj = { 
                    "user_assessment":unstringlyDataObj.data.user_assessment,
                    "user": unstringlyDataObj.data.user, 
                    "dev_plan_id": unstringlyDataObj.data.data.id, 
                    "dev_plan_name": unstringlyDataObj.data.data.development_plan_name
                }
            }
            else if(unstringlyDataObj.key === 'report'){
                dataObj = { 
                    "user_assessment":unstringlyDataObj.data.user_assessment,
                    "user": unstringlyDataObj.data.user,
                    "relation_group_id":unstringlyDataObj.data.data.relation_group_id,
                    "relation_group_name":unstringlyDataObj.data.data.relation_group_name,
                    "screen_type": unstringlyDataObj.screen_type,
                    "orientation_list": unstringlyDataObj.data.orientation_list || []
                }
            }else if (unstringlyDataObj.key === 'self-report'){
                dataObj = {
                    "user_assessment": unstringlyDataObj.data.user_assessment,
                    "user": unstringlyDataObj.data.user,
                    "screen_type": unstringlyDataObj.screen_type,
                    "relation_group_id": unstringlyDataObj.data.relation_group_id,
                    "relation_group_name": unstringlyDataObj.data.relation_group_name,
                    "orientation_list": unstringlyDataObj.data.orientation_list || []
                }

            }else if(unstringlyDataObj.key === 'self'){
                dataObj = {
                    "user_assessment":unstringlyDataObj.data.user_assessment,
                    "user": unstringlyDataObj.data.user,
                    "screen_type": unstringlyDataObj.screen_type,
                    "relation_group_id":28,
                    "relation_group_name":"Self report"
                }
            }else if(unstringlyDataObj.key === 'ROLE_FITMENT'){
                dataObj = unstringlyDataObj.data;
            }else if(unstringlyDataObj.key === 'ROLE_FITMENT_LOI'){
                dataObj = unstringlyDataObj.data;
            }else if(unstringlyDataObj.key === 'VVI') {
                dataObj = {
                    "user_assessment":unstringlyDataObj.data.user_assessment,
                    "user": unstringlyDataObj.data.user
                }
            }else if(unstringlyDataObj.key === "vpiScore") {
                dataObj = unstringlyDataObj.data.data
            }else if(unstringlyDataObj.key === 'vpiRawScore') {
                dataObj = {
                    "user_assessment_id":unstringlyDataObj.data.user_assessment,
                    "user_id": unstringlyDataObj.data.user
                }
            }else {
                dataObj = {
                    "user_assessment":unstringlyDataObj.data.user_assessment,
                    "user": unstringlyDataObj.data.user
                }
            }

            this.props.dispatch(dashBoardAction.getPdfAction(dataObj, unstringlyDataObj.key, (dataFromApi) => {
              
                let removedDelimitter = {};
                let splitString = [];
                let currentLink = "";
                let dataUrlOrObject = dataFromApi.data.url;
                if(dataUrlOrObject.file) {  
                     splitString = dataUrlOrObject.file.filename.split('/');
                }else {
                    removedDelimitter = JSON.parse(dataUrlOrObject.replace("\\", ''));
                    splitString = removedDelimitter.file.filename.split('/');
                }

                currentLink = splitString[splitString.length - 1];
                window.location.replace(`${DownloadPdfEndPoint}${currentLink}`);
                localStorage.removeItem('download-obj');
                
            }))
        }else {
                this.props.dispatch(GroupReportAction.groupReportPDF(unstringlyDataObj.data, (dataFromApi, error) => {
                   
                    if(error !== undefined) {
                        if(dataFromApi.response.data.message !== undefined) {
                            that.setState({
                                error: true,
                                errorMessage: dataFromApi.response.data.message
                            })
                        }
                    }
                    let removedDelimitter = JSON.parse(dataFromApi.data.url.replace("\\", ''));
                    let splitString = removedDelimitter.file.filename.split('/');
                    let currentLink = splitString[splitString.length - 1];
                    window.location.replace(`${DownloadPdfEndPoint}${currentLink}`);
                    localStorage.removeItem('download-obj')
                }))
        }
        

    }
    render() {
        return (
            <div>
                <div  style={this.state.error ? {display: 'none' ,height: '100vh', width: '100vw', justifyContent: 'center', alignItems: 'center'} : { height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                   
                    <div>
                        <h4 className="text-center" >Please wait while we load the PDF...</h4>
                        <div style={{margin: 'auto',width:'100%',height:'100%'}} class="lds-facebook"><div></div><div></div><div></div></div>
                    </div>
                </div>
                <div class="errorBox" style={this.state.error ? {display: 'flex'} : {display: 'none'}}>
                    <div class="text-center">
                        <p>{this.state.errorMessage}</p>
                        <button class="btn btn-danger" onClick={() => window.close()}>Close TAB</button>
                    </div>
                </div>
            </div>
        )
    }
    
}

export default connect()(ReportDownlaod);


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/viewReport/ReportDownlaod.js